<template>
    <div class="translate">
        <span style="font-size: 10vh;">{{ texto_pt }}</span>
        <br>
        <span style="font-size: 10vh;">{{ texto_en }}</span>
        <br>
        <div class="translate_control" lang="en"></div>
        <span @click="traduz()" style="cursor: pointer; font-size: 10vh;">Traduzir</span>
    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'
    import axios from 'axios'

    export default {
        mixins: [advMixin],
        name: 'Home',
        data () {
            return {
                name: 'Home',
                texto_pt: 'Esse texto deve ser traduzido',
                texto_en: '',
            }
        },
        methods: {
            getPanoImg() {
                return this.pano[this.panoInd].imgPath;
            },
            // https://blog.api.rakuten.net/top-10-best-translation-apis-google-translate-microsoft-translator-and-others/
            // https://stackoverflow.com/questions/37667671/is-it-possible-to-access-to-google-translate-api-for-free
            traduz() {
                var sourceText = this.texto_pt;
                var sourceLang = 'pt';
                var targetLang = 'en';
                var vm = this;

                /* Option 2 */
                var url = "https://translate.googleapis.com/translate_a/single?client=gtx&sl="
                    + sourceLang + "&tl=" + targetLang + "&dt=t&q=" + encodeURI(sourceText);

                axios.get(url)
                    .then(function (response) {
                        // var result = JSON.parse(response.data);
                        var result = response.data;
                        console.log('result: ', result);

                        var translatedText = result[0][0][0];

                        console.log('translatedText: ', translatedText);

                        vm.texto_en = translatedText;

                        var json = {
                            'sourceText' : sourceText,
                            'translatedText' : translatedText
                        };
                    });


            }
        },
        created() {

            console.log('created!!');


            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');

            // this.trans2('en');

            console.log('Terminei o mounted!!');
        },

    }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Homecp.vue